import { Patient } from "@/Common/Models/Patient/Patient";
import { PortalCommunicationComposite } from "@/Common/Models/PortalCommunication/PortalCommunicationComposite";
import { PortalCommunicationsThreadItemComponent } from "./PortalCommunicationsThreadItemComponent";

import styles from "./PortalCommunicationsThreadsViewComponent.module.scss";

interface IPortalCommunicationsThreadsViewComponentProps {
    patient: Patient;
    selectedSharedItemId: string | null;
    threads: PortalCommunicationComposite[];
    onClick: (sharedItemId: string) => void;
}

export function PortalCommunicationsThreadsViewComponent(props: Readonly<IPortalCommunicationsThreadsViewComponentProps>): JSX.Element {
    return (
        <div className={styles.threadsContainer}>
            {props.threads?.map(p => (
                <PortalCommunicationsThreadItemComponent
                    key={p.sharedItem.SharedItemId}
                    threadItem={p}
                    isSelected={p.sharedItem.SharedItemId === props.selectedSharedItemId}
                    onClick={sharedItemId => { props.onClick(sharedItemId); }}
                />
            ))}
        </div>
    );
}
